// Copyright 2019-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import ConfigLoader from "./ConfigLoader";

export default ConfigLoader;
